import { SUPPORTED_COUNTRIES } from '@/common/constants/countries'
import { LANGUAGES } from '@/common/constants/languages'
import { z } from '@/lib/zod'

export const FilterAccountsSchema = () =>
  z.object({
    freeSearch: z.string().nullable().optional(),
    locale: z
      .enum([...LANGUAGES])
      .nullable()
      .optional(),
    country: z
      .enum([...SUPPORTED_COUNTRIES])
      .nullable()
      .optional(),
    tag: z.string().nullable().optional(),
    isActive: z.boolean().nullable().optional().default(false),
  })

export type FilterAccountsForm = z.infer<
  ReturnType<typeof FilterAccountsSchema>
>
